import { ExtraFieldValidationModel } from './extra-field-validation.model';
import { ExtraFieldTypeModel } from './extra-field-type.model';
import { ExtraFieldOptionModel } from './extra-field-option.model';
import { FillableModel } from './fillable.model';

export class ExtraFieldModel extends FillableModel {
    public id: number = null;
    public label: string = null;
    public slug: string = null;
    public extra_field_type: ExtraFieldTypeModel = null;
    public options: Array<ExtraFieldOptionModel> = [];
    public validations: Array<ExtraFieldValidationModel> = [];
    public form_id: number = null;
}



// WEBPACK FOOTER //
// /codebuild/output/src2645790472/src/src/app/shared/models/extra-field.model.ts